import React from "react";
import { getUserCurrencySymbol } from "utils/AuthUtil";
import constants from "constants/constants";

export const AmountField = ({ domesticPrice, internationalPrice }) => {
  return (
    <div>
      {getUserCurrencySymbol()}&nbsp;{domesticPrice}
      {internationalPrice ? (
        <span>
          {" "}
          or {constants.usd_currency}
          {internationalPrice}
        </span>
      ) : (
        <></>
      )}
    </div>
  );
};
